import styled from "styled-components";

export const DeviceDetailsWrapper = styled.div`
    display: grid;
    width: 100%;
    padding: 10px;
    overflow-x: hidden;
    overflow-y: hidden;
    grid-gap: 10px ;
    grid-template-rows: 1;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
    letter-spacing: 1px;
`;

export const InfoItem = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 72px;
    padding: 5px 12px;
    box-sizing: border-box;
    border: 1px solid rgb(95, 112, 150, 0.3);
    font-size: 20px;
`;

export const InfoLabel = styled.span`
    font-size: 18px;
    opacity: 0.5;
`;

export const InfoValue = styled.span`
    display: inline-block;
    font-size: 20px;
    margin-top: 6px;
    max-width: 100%;
    /* allow wrapping instead of ellipsis */
    height: auto;
    display: flex;
    align-items: flex-start;
    overflow: visible;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    
`;
